import { render, staticRenderFns } from "./TheCarousel.vue?vue&type=template&id=4d7eb6f6&scoped=true"
import script from "./TheCarousel.vue?vue&type=script&lang=js"
export * from "./TheCarousel.vue?vue&type=script&lang=js"
import style0 from "./TheCarousel.vue?vue&type=style&index=0&id=4d7eb6f6&prod&scoped=true&lang=css"
import style1 from "./TheCarousel.vue?vue&type=style&index=1&id=4d7eb6f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7eb6f6",
  null
  
)

export default component.exports